function MemberMemberModel(MemberService, BBModel, ClientModel) {
    'ngInject';

    class Member_Member extends ClientModel {

        static $refresh(member) {
            return MemberService.refresh(member);
        }

        static $current() {
            return MemberService.current();
        }

        static $updateMember(member, params) {
            return MemberService.updateMember(member, params);
        }

        static $sendWelcomeEmail(member, params) {
            return MemberService.sendWelcomeEmail(member, params);
        }

        getBookings(params) {
            return BBModel.Member.Booking.$query(this, params);
        }
    }

    return Member_Member;
}

angular
    .module('BBMember')
    .service('Member.MemberModel', MemberMemberModel);


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/member/_models/member_member_model.service.js